export default __webpack_public_path__ + "static/media/screenshot3.c15c8d69.jpg";